import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { CMSContent } from 'sg-ui-components';

const CMSModal = ({ show, onHide, contentPathForHeader, contentPathForBody, cmsSourceFirebase }) => {
    return (
        <Modal id='cms-modal' show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <CMSContent localStorageObject='webContent' contentPath={contentPathForHeader} cmsSourceFirebase={cmsSourceFirebase} />
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <CMSContent localStorageObject='webContent' contentPath={contentPathForBody} cmsSourceFirebase={cmsSourceFirebase} />
            </Modal.Body>

            <Modal.Footer className='mx-auto'>
                <Button className='btn theme-btn theme-secondary' onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CMSModal;
